// /hooks/use-all-balances.ts
import { useSolanaBalances } from "./use-solana-balances";
import { useEVMBalances } from "./use-evm-balances";

interface UseAllBalancesProps {
  solanaWalletAddress: string | null;
  userId: string | null;
  refetchInterval?: number;
  enabled?: boolean;
}

export function useAllBalances({
  solanaWalletAddress,
  userId,
  refetchInterval = 30000,
  enabled = true,
}: UseAllBalancesProps) {
  const solanaBalances = useSolanaBalances({
    walletAddress: solanaWalletAddress || "",
    refetchInterval,
    enabled: enabled && !!solanaWalletAddress,
  });

  const evmBalances = useEVMBalances({
    userId,
    refetchInterval,
    enabled: enabled && !!userId,
  });

  const loading = solanaBalances.loading || evmBalances.loading;
  const refreshing = solanaBalances.refreshing || evmBalances.refreshing;
  const error = solanaBalances.error || evmBalances.error;

  const refetchAll = () => {
    solanaBalances.refetch();
    evmBalances.refetch();
  };

  // Add Tron balances to evmBalances structure
  const allEvmBalances = {
    ...evmBalances.balances,
    tron: evmBalances.balances?.tron || { TRX: 0, USDT: 0 }
  };

  return {
    solanaBalances: solanaBalances.balances,
    evmBalances: allEvmBalances,
    loading,
    refreshing,
    error,
    refetch: refetchAll,
  };
}
